import axios from "axios";
import { useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import DatePicker from "react-datepicker";
import { Link, useSearchParams } from "react-router-dom";
import { API_CONSTANTS } from "../../common/constants/api";
import { IBusLocation } from "../../common/types";
import { SESSION_KEYS } from "../../common/constants/sessionKeys";
import { Flex, Heading, IconButton, Text } from "@radix-ui/themes";
import BannerCarousel from "../../components/BannerCarousel/BannerCarousel";
import styles from "./Home.module.scss";
import { Col } from "react-bootstrap";
import { HeightIcon, WidthIcon } from "@radix-ui/react-icons";

const Home = () => {
  const [searchParams] = useSearchParams();
  const [fromLocation, setFromLocation] = useState<IBusLocation[]>([]);
  const [toLocation, setToLocation] = useState<IBusLocation[]>([]);
  const [jDate, setJDate] = useState<Date | null>(null);
  const [allLocations, setAllLocations] = useState<IBusLocation[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const clearSearch = () => {
    setFromLocation([]);
    setToLocation([]);
    setJDate(null);

    sessionStorage.removeItem(SESSION_KEYS.FROM_LOCATION);
    sessionStorage.removeItem(SESSION_KEYS.FROM_LOCATION_CODE);
    sessionStorage.removeItem(SESSION_KEYS.TO_LOCATION);
    sessionStorage.removeItem(SESSION_KEYS.TO_LOCATION_CODE);
  };

  const getFormattedTime = (d: Date | null) => {
    if (!d) {
      return "";
    }
    return `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${(
      "0" + d.getDate()
    ).slice(-2)}`;
    /* return (
      ("0" + d.getDate()).slice(-2) +
      "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) +
      "-" +
      d.getFullYear() /* +
      " " +
      ("0" + d.getHours()).slice(-2) +
      ":" +
      ("0" + d.getMinutes()).slice(-2)
    ); */
  };
  /* console.log("fromLocation", fromLocation);
  console.log("toLocation", toLocation);
  console.log("jDate", jDate); */

  const swapLocationsHandler = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();
    evt.stopPropagation();
    const _fromLocation = fromLocation;
    const _toLocation = toLocation;
    setFromLocation(_toLocation);
    setToLocation(_fromLocation);

    if (_toLocation[0]) {
      sessionStorage.setItem(
        SESSION_KEYS.FROM_LOCATION_CODE,
        `${_toLocation[0]?.busStopId}`
      );
      sessionStorage.setItem(
        SESSION_KEYS.FROM_LOCATION,
        `${_toLocation[0]?.busStopName}`
      );
    } else {
      sessionStorage.removeItem(SESSION_KEYS.FROM_LOCATION);
      sessionStorage.removeItem(SESSION_KEYS.FROM_LOCATION_CODE);
    }

    if (_fromLocation[0]) {
      sessionStorage.setItem(
        SESSION_KEYS.TO_LOCATION_CODE,
        `${_fromLocation[0]?.busStopId}`
      );
      sessionStorage.setItem(
        SESSION_KEYS.TO_LOCATION,
        `${_fromLocation[0]?.busStopName}`
      );
    } else {
      sessionStorage.removeItem(SESSION_KEYS.TO_LOCATION);
      sessionStorage.removeItem(SESSION_KEYS.TO_LOCATION_CODE);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(API_CONSTANTS.BUS_LOCATIONS)
      .then((res) => {
        setAllLocations(res.data);
      })
      .catch((err) => {
        // keep console for debugging; tests can mock axios
        // eslint-disable-next-line no-console
        console.error("Failed to load bus locations", err);
      })
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (allLocations.length > 0) {
      const _fromLoc = searchParams.get("from");
      const _toLoc = searchParams.get("to");
      const _jDate = searchParams.get("date");
      if (_fromLoc && _toLoc && _jDate) {
        const _fromLocation: IBusLocation | undefined = allLocations.find(
          (loc) => loc.busStopId === parseInt(_fromLoc)
        );
        const _toLocation: IBusLocation | undefined = allLocations.find(
          (loc) => loc.busStopId === parseInt(_toLoc)
        );
        console.log("_fromLocation", _fromLocation);
        console.log("_toLocation", _toLocation);
        console.log("_jDate", _jDate);
        if (_fromLocation) {
          setFromLocation([_fromLocation]);
        }
        if (_toLocation) {
          setToLocation([_toLocation]);
        }
        setJDate(new Date(_jDate));
      }
    }
  }, [searchParams, allLocations]);

  return (
    <div className={`container ${styles.HomeContainer}`}>
      <Heading
        as="h1"
        color="blue"
        align="center"
        className="pb-2 border-bottom text-primary my-2"
      >
        Welcome Traveller
      </Heading>

      {isLoading ? (
        <div className="d-flex justify-content-center my-5" role="status">
          <div className="spinner-border text-primary" aria-hidden="true" />
          <span className="visually-hidden">Loading...</span>
        </div>
      ) : (
        <form>
          <div className="row my-5">
            <Col
              xs="12"
              lg="4"
              md="6"
              className={`mt-5 mb-3 ${styles.formItemContainer}`}
            >
              <label
                htmlFor="fromLocation"
                className={`col-form-label ${styles.formItemLabel}`}
              >
                <Text as="span" size="3">
                  From
                </Text>
              </label>
              <Typeahead
                id="fromLocation"
                onChange={(_selected) => {
                  setFromLocation(_selected as IBusLocation[]);
                  sessionStorage.setItem(
                    SESSION_KEYS.FROM_LOCATION_CODE,
                    `${(_selected as IBusLocation[])[0]?.busStopId}`
                  );
                  sessionStorage.setItem(
                    SESSION_KEYS.FROM_LOCATION,
                    `${(_selected as IBusLocation[])[0]?.busStopName}`
                  );
                  console.log("fromLocation->_selected", _selected);
                }}
                options={allLocations}
                labelKey={"busStopName"}
                placeholder="from"
                aria-label="fromLocation"
                aria-describedby="from location"
                selected={fromLocation}
                className={styles.typeahead}
              />
            </Col>
            <Col
              xs="12"
              lg="1"
              md="1"
              className={`mt-5 mb-3 ${styles.formIconContainer}`}
            >
              <Flex justify="center" align="center">
                <IconButton variant="outline" onClick={swapLocationsHandler}>
                  <WidthIcon
                    width="18"
                    height="18"
                    className={styles.widthIcon}
                  />
                  <HeightIcon
                    width="18"
                    height="18"
                    className={styles.heightIcon}
                  />
                </IconButton>
              </Flex>
            </Col>
            <Col
              xs="12"
              lg="4"
              md="5"
              className={`mt-5 mb-3 ${styles.formItemContainer}`}
            >
              <label
                htmlFor="toLocation"
                className={`col-form-label ${styles.formItemLabel}`}
              >
                <Text as="span" size="3">
                  To
                </Text>
              </label>
              <Typeahead
                id="toLocation"
                onChange={(_selected) => {
                  console.log("toLocation->_selected", _selected);
                  sessionStorage.setItem(
                    SESSION_KEYS.TO_LOCATION_CODE,
                    `${(_selected as IBusLocation[])[0]?.busStopId}`
                  );
                  sessionStorage.setItem(
                    SESSION_KEYS.TO_LOCATION,
                    `${(_selected as IBusLocation[])[0]?.busStopName}`
                  );
                  setToLocation(_selected as IBusLocation[]);
                }}
                options={allLocations}
                placeholder="To"
                labelKey={"busStopName"}
                aria-label="toLocation"
                aria-describedby="to location"
                selected={toLocation}
                className={styles.typeahead}
              />
            </Col>
            <Col
              xs="12"
              lg="3"
              md="6"
              className={`mt-5 mb-3 ${styles.formItemContainer}`}
            >
              <label
                htmlFor="journeyDate"
                className={`col-form-label ${styles.formItemLabel}`}
              >
                <Text as="span" size="3">
                  Date
                </Text>
              </label>
              <DatePicker
                selected={jDate}
                onChange={(e) => setJDate(e)}
                className={`form-control ${styles.datePicker}`}
                name="journeyDate"
                placeholderText="Date"
                aria-label="journey"
                aria-describedby="journey Date"
                id="journeyDate"
                dateFormat="dd/MM/yyyy"
              />
            </Col>
            <div className="col-lg-6 col-12">
              <section className="position-relative">
                <div className="my-5 row">
                  <div className="col-6">
                    <a
                      className={`btn btn-outline-primary btn-lg ${
                        !fromLocation?.[0]?.busStopId ||
                        !toLocation?.[0]?.busStopId ||
                        !jDate
                          ? "disabled"
                          : ""
                      }`}
                      href={`/buses?from=${fromLocation?.[0]?.busStopId}&to=${
                        toLocation?.[0]?.busStopId
                      }&date=${getFormattedTime(jDate)}`}
                    >
                      <Text as="span" size="3">
                        Search
                      </Text>
                    </a>
                  </div>
                  <div className="col-6">
                    <button
                      type="button"
                      disabled={!fromLocation?.[0] && !toLocation?.[0] && !jDate}
                      className="btn btn-outline-primary btn-lg"
                      onClick={clearSearch}
                    >
                      <Text as="span" size="3">
                        Clear
                      </Text>
                    </button>
                  </div>
                </div>
              </section>
            </div>
            <div className="col-lg-6 col-12">
              {/*  <div
              className="card text-center shadow-lg border-0"
              style={{
                background: "linear-gradient(90deg, #1976d2 0%, #64b5f6 100%)",
                color: "#fff",
              }}
            >
              <div className="card-body py-5">
                <Heading as="h3" size="5" className="mb-3">
                  Book Your Bus Tickets Instantly!
                </Heading>
                <Text as="p" size="4" className="mb-4">
                  Discover routes, compare prices, and reserve your seat in
                  seconds. Enjoy a seamless travel experience with QuickBus.
                </Text>
                <a
                  href="/buses"
                  className="btn btn-light btn-lg fw-bold"
                  style={{ color: "#1976d2" }}
                >
                  Book Now
                </a>
              </div>
            </div> */}
            </div>
          </div>
          <div className="row my-5">
            <div className="col-12">
              {/* Full-width carousel banner */}
              {/*  <BannerCarousel /> */}
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default Home;
